<template>
  <table class="table">
    <tbody>
      <tr v-for="item in props.characteristic" :key="item.id">
        <td class="font-semibold text-gray-500">{{ item.name }}</td>
        <td class="font-semibold">{{ item.value }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script lang="ts" setup>
import { type TProductCharacteristic } from '@/types/book_item'

const props = defineProps<{
  characteristic: TProductCharacteristic[]
  miniMode?: boolean
}>()
</script>
